import CustomerLocationModel from "@/models/crm/CustomerLocationModel";
import CrmServiceCollection from "@/collections/CrmServiceCollection";

/**
 * Customer collection
 */
export default class CustomerLocationCollection extends CrmServiceCollection {

  // Model that is contained in this collection.
  model() {
    return CustomerLocationModel;
  }

}
